import React from "react";
import BrandIdentity from "./BrandIdentity";
import { useBrand } from "../../context/BrandContext";
import { DEVELOPER_CREDIT } from "../../config/developer";
import "./AppLoadingScreen.css";

/**
 * Full-screen loading overlay shown during:
 *  - Initial app boot (auth check)
 *  - Route-level data fetching
 *  - Any long async operation
 *
 * Props:
 *   message {string} - optional Arabic label beneath the spinner
 *   overlay {bool}   - if true, uses semi-transparent overlay instead of full-screen fill
 *   showLogo {bool}  - if false, hide BrandIdentity (used during brand boot
 *                      so the ESS/default logo cannot flash before the real
 *                      brand is known)
 */
function AppLoadingScreen({
  message = "جارٍ التحميل...",
  overlay = false,
  showLogo = true,
}) {
  const brand = useBrand();
  const appName = brand.appName || brand.companyName || brand.shortName || "ESS HRMS";
  return (
    <div className={overlay ? "app-loading-overlay" : "app-loading-screen"}>
      <div className="app-loading-content">
        {showLogo && (
          <div className="app-loading-brand">
            <div className="app-loading-logo">
              <div className="app-loading-logo-inner">
                <BrandIdentity
                  showName={false}
                  logoClassName="app-loading-logo-img"
                  fallbackClassName="app-loading-logo-text"
                />
              </div>
            </div>
            <p className="app-loading-app-name" dir="ltr" lang="en">
              {appName}
            </p>
            <p className="app-loading-slogan">
              {brand.slogan || "إدارة أذكى لفريقك"}
            </p>
            <p className="app-loading-developer" dir="ltr" lang="en">
              {DEVELOPER_CREDIT}
            </p>
          </div>
        )}

        <div className="app-loading-spinner-ring">
          <div className="app-loading-ring" />
          <div className="app-loading-ring app-loading-ring--2" />
        </div>

        {message && <p className="app-loading-message">{message}</p>}
      </div>
    </div>
  );
}

export default AppLoadingScreen;
